import type {
    QuickComposeViewType,
    FullComposeFormViewType,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import {
    getFullComposeViewState,
    getQuickComposeViewState,
} from 'owa-calendar-compose-store-manager';

export function getViewTypeForLogging(
    formId: string
): QuickComposeViewType | FullComposeFormViewType {
    return getFullComposeViewState(formId)?.viewType || getQuickComposeViewState(formId)?.viewType;
}
